import angular from 'angular';

import ChipSelectorComponent from './chip-selector.component';

const ChipSelectorModule = angular
    .module('control-room.commons.form.components.chip-selector', [])
    .component('crChipSelector', ChipSelectorComponent);

export default ChipSelectorModule;
